import { useMemo } from 'react';
import type { GoodsBasicResponse } from 'shared/src/api/goodsService/getGoodsBasic/types';
import { useConfigs } from 'shared/src/queries';
import { getHour, isNil, isNotNil } from 'shared/src/utils';

export const useGetDeliveryOrderDeadlineTime = (
  goodsBasic: GoodsBasicResponse['goods'] | undefined,
) => {
  const { data: configs } = useConfigs();
  return useMemo(() => {
    if (isNil(goodsBasic)) return null;

    if (goodsBasic.delivery_type_info.delivery_type === 'shak') {
      //shak은 18:00 고정
      return getHour(configs?.shak_delivery.operation_end_time);
    }

    if (goodsBasic.delivery_type_info.delivery_type === 'today') {
      if (isNotNil(goodsBasic.market.today_delivery_order_deadline_time)) {
        //today는 마켓마다 다름
        return getHour(goodsBasic.market.today_delivery_order_deadline_time);
      }
    }

    return null;
  }, [configs?.shak_delivery.operation_end_time, goodsBasic]);
};
